module.exports = __webpack_public_path__ + "img/icon-facebook.d48fd6ff.svg";